import React, { useState, useEffect } from 'react'
import gql from 'graphql-tag'
import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import PauseIcon from "../../assets/img/block.png";
import { FaRegArrowAltCircleLeft, FaArrowAltCircleLeft, FaArrowCircleRight, FaRegArrowAltCircleRight } from "react-icons/fa";
import { addToDataLayerGTM } from "../../utils/addToDataLayerGTM";
import axios from 'axios'

import banner_default from '../../assets/img/portoEduc_Bn_Porto_Educast_Home.jpg'
import micIcon from '../../assets/img/microphone.svg'
import playIcon from '../../assets/img/podcasts-play.svg'

import Config from '../../config/config'
import HttpLinkServices from '../../services/HttpLinkServices'
import getCookie from '../../components/Cookie/Cookie.jsx'

import Spinner from '../../components/Spinner'
import SearchNotFound from '../../components/SearchNotFound'

import './styles.css'

const GET_USER_METAS = gql`
  query get_user_metas($token: String!) {
    get_user_by_token(token: $token) {
      userMetas {
        account_field {
          id
        }
      }
    }
  }
`;

const Podcasts = () => {
  const [userHasAccess, setUserHasAccess] = useState(false)
  const [activePodcast, setActivePodcast] = useState(null)
  const [errorMessage, setErrorMessage] = useState('Não há podcasts disponíveis.')
  const [isLoading, setIsLoading] = useState(true)
  const [isPodcastLoading, setIsPodcastLoading] = useState(true)
  const [tagButtonStatus, setTagButtonStatus] = useState(true);
  const [playPause, setPlayPause] = useState(true);

  const [podcasts, setPodcasts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [podcastsPerPage, setPodcastsPerPage] = useState(5);
  const [totalPages, setTotalPages] = useState(0);
  const [offsetDone, setOffsetDone] = useState([0]);
  const [loandingPagination, setLoadingPagination] = useState(false);

  let offset = 0;

  const handlePlaylistClick = playlistUri => {
    setIsPodcastLoading(true);
    setActivePodcast(playlistUri);
    setTagButtonStatus(true);
    setPlayPause(true);
  };

  const handleTagButton = () => {
    const { name } = podcasts.find((element) => element.id === activePodcast);
    setTagButtonStatus(false);
    setTimeout(() => {
      setTagButtonStatus(true);
    }, 5000);
    if (playPause) {
      setPlayPause(false);
      addToDataLayerGTM({
        'event': 'podcast_change',
        'titulo': `${name}`,
        'status': 'start'
      })
    } else {
      setPlayPause(true);
      addToDataLayerGTM({
        'event': 'podcast_change',
        'titulo': `${name}`,
        'status': 'pause'

      })
    }
  };

  async function getPodcasts(limit, offset) {

    let allPodcasts = [];

    const res = axios.get(`${Config.baseUrl}/api/v1/lms/get_podcast_playlist`,  {
      params: {
        limit: limit,
        offset: offset
      }
    })
    .then(res => {

      allPodcasts = podcasts.concat(res.data.items);
      setPodcasts(allPodcasts);
      setActivePodcast(allPodcasts[0].id);
      setTotalPages(Math.ceil(res.data.total / podcastsPerPage));
      setLoadingPagination(false);

    })
    .catch(() => {
      setErrorMessage('Ocorreu um erro ao buscar a playlist.')
      setUserHasAccess(false)
    })
    .finally(() => {
        setIsLoading(false)
    })

  }

  useEffect(() => {
    setIsLoading(true);

    const account_client = new ApolloClient({
      link: HttpLinkServices.account,
      cache: new InMemoryCache()
    });

    // Verifica se o usuário tem acesso (Corretores e Colaboradoes)
    account_client
      .query({
        query: GET_USER_METAS,
        variables: { token: getCookie("token_user") }
      })
      .then(res => {
        const userMetas = res.data.get_user_by_token.userMetas
        const userAccess = userMetas.find(userMeta =>
          userMeta.account_field.id === 11 || userMeta.account_field.id === 17
        )

        if (userAccess) {

          setUserHasAccess(true)
          getPodcasts( 50, 0);

        } else {
          setUserHasAccess(false)
          setIsLoading(false)
        }
      })
      .catch(() => {
        setUserHasAccess(false);
        setIsLoading(false);
      });
  }, []);

  /** */

  const handleNextPage = () => {
    setCurrentPage(currentPage + 1);
    offset = currentPage * podcastsPerPage;
    let allOffsets = [];
    allOffsets = offsetDone.concat(offset);

    if(offset % 50 === 0 && !offsetDone.includes(offset)){ 

      setLoadingPagination(true);
      getPodcasts(50, offset);
      allOffsets = offsetDone.concat(offset);
      setOffsetDone(allOffsets);

    }
  }

  const handlePreviousPage = () => {
    setCurrentPage(currentPage - 1);
  }

  /** */
  return (
    <div>
      <img className="banner_content" src={banner_default} />

      <div className="podcasts-container">
        <div className="podcasts-content">
          {isLoading && (
            <div className="podcasts-page-spinner">
              <Spinner />
            </div>
          )}

          {!userHasAccess && !isLoading && (
            <SearchNotFound
              message={errorMessage}
              onClick={() => (window.location.href = "/#/home")}
              buttonMessage="Voltar a página inicial"
            />
          )}

        {
          userHasAccess && !isLoading &&
          <React.Fragment>
            <div className='podcasts-playlist'>
              <div className='podcast-list'>
                <h3 className='podcasts-playlist-title'>
                  <img src={micIcon} className='podcasts-mic-icon' />
                  Playlist
                </h3>

                <ul className='podcasts-playlist-list'>
                  {loandingPagination ?
                    ( 
                      <div className='podcast-pagination-spinner'>
                        <Spinner />
                      </div>
                    )
                    : 
                    ( 
                      podcasts.map((podcast, index) =>
                        index >= (currentPage - 1) * podcastsPerPage && index < currentPage * podcastsPerPage &&
                          <div key={index}>
                            <li>
                              {
                                podcast.id === activePodcast &&
                                <div className='podcasts-play-box'>
                                  <img src={playIcon} />
                                </div>
                              }
    
                              <button
                                data-gtm-type="click"
                                data-gtm-clicktype="button"
                                data-gtm-name={ podcast.name }
                                data-gtm-subname="playlist-podcast"
                                className={`podcasts-playlist-button ${podcast.id === activePodcast && 'podcasts-playlist-button-active'}`}
                                onClick={() => handlePlaylistClick(podcast.id)}
                              >
                                {podcast.name}
                              </button>
    
                            </li>
                            <hr className={`podcasts-playlist-hr ${podcast.uri === activePodcast && 'podcasts-playlist-hr-hide'}`} />
                          </div>
                        )
                    )
                  }
                </ul>
              </div>
              <div className="podcast-pagination">
                <button className="podcast-previous" onClick={handlePreviousPage} disabled={currentPage === 1}><FaRegArrowAltCircleLeft className='podcast-page-icon'/></button>
                <span className="podcast-page-number">{currentPage}/{totalPages}</span>
                <button className="podcast-next" onClick={handleNextPage} disabled={currentPage === totalPages}><FaRegArrowAltCircleRight className='podcast-page-icon'/></button>
              </div>
            </div>

            <div className='podcasts-iframe'>
              {isPodcastLoading && <div className='podcasts-iframe-spinner'><Spinner /></div>}
              <p className={tagButtonStatus ? 'tagMessage' : 'tagDisplayNone'}>Clique no cadeado para liberar o player</p>
              <button onClick={handleTagButton} type='button' className={tagButtonStatus ? 'tagButtonPlay' : 'tagDisplayNone'}><img src={PauseIcon} alt="Tag" /></button>
              <iframe
                src={`https://open.spotify.com/embed-podcast/episode/${activePodcast}`}
                width="100%"
                height='232'
                frameBorder="0"
                allowtransparency="true"
                allow="encrypted-media"
                onLoad={() => setIsPodcastLoading(false)}
              >
              </iframe>
            </div>
          </React.Fragment>
        }
        </div>
      </div>
    </div>
  );
};

export default Podcasts;


// WEBPACK FOOTER //
// ./src/views/Podcasts/index.jsx